import { toast } from "react-toastify";

// Upload size limits were removed — any size of image or video can be uploaded.
// The constants stay (as null = "no limit") so existing pages keep working.
export const MAX_IMAGE_MB = null;
export const MAX_BANNER_IMAGE_MB = null;
export const MAX_VIDEO_MB = null;

// Returns true if the file is within the limit, otherwise shows a toast and returns false.
// With no limit (maxMB empty) every file is accepted.
export const checkFileSize = (file, maxMB, label = "File") => {
  if (!file || !maxMB) return true;
  if (file.size > maxMB * 1024 * 1024) {
    toast.error(`${label} size should not exceed ${maxMB} MB`);
    return false;
  }
  return true;
};

// Downloads a (possibly cross-origin) file by fetching it as a blob,
// since the <a download> attribute is ignored for other origins.
export const downloadFile = async (url, fallbackName = "download") => {
  if (!url) {
    toast.error("No file to download");
    return;
  }
  const fileName = url.split("/").pop().split("?")[0] || fallbackName;
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    const blob = await response.blob();
    const blobUrl = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(blobUrl);
  } catch (error) {
    console.error("Download failed, opening in new tab:", error);
    window.open(url, "_blank", "noopener,noreferrer");
  }
};
